import { render, staticRenderFns } from "./content-featured-carousel.vue?vue&type=template&id=4ad0bf2d&scoped=true"
import script from "./content-featured-carousel.vue?vue&type=script&lang=js"
export * from "./content-featured-carousel.vue?vue&type=script&lang=js"
import style0 from "./content-featured-carousel.vue?vue&type=style&index=0&id=4ad0bf2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad0bf2d",
  null
  
)

export default component.exports